<template>
  <v-row no-gutters v-if="lineProperties">
    <v-col cols="12">
      <v-row no-gutters v-for="(input, idx) of inputs" :key="idx" class="text-body-2">
        <template v-if="input.name === 'coordinates'">
          <v-col cols="12">
            <v-row
              no-gutters
              v-for="(coordinate, idx) of lineProperties.coordinates"
              :key="idx"
              class="pt-5"
              align="center"
            >
              <v-col cols="4" class="line-summary-title-col pr-7"> {{ coordinate.verboseName }}: </v-col>
              <v-col cols="8" class="font-weight-medium">
                {{ formatCoordinates(coordinate.coordinates) }}
              </v-col>
            </v-row>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12">
            <v-row no-gutters class="pt-5" align="center">
              <v-col cols="4" class="line-summary-title-col pr-7"> {{ input.verboseName }}: </v-col>
              <v-col cols="6" class="font-weight-medium">
                {{ lineProperties[input.name] }}
              </v-col>
              <v-spacer />
              <v-col cols="2" class="text-right">
                <slot :name="`${input.name}-append`" />
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import { transform } from 'ol/proj';
import { GeoJSON } from 'ol/format';
import { getLength } from 'ol/sphere';
export default {
  name: 'LineSummary',
  props: {
    geometry: {
      // GeoJSON
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    cursorPositionEpsg: get('map/cursorPositionEpsg'),
    inputs() {
      return [
        {
          name: 'length',
          verboseName: this.$i18n.t('sidebar.lineSummary.length'),
        },
        {
          name: 'coordinates',
        },
      ];
    },
  },
  data: () => ({
    lineProperties: undefined,
  }),
  methods: {
    formatLength(geometry) {
      const length = getLength(geometry);
      if (length > 1000) {
        return `${Math.round((length / 1000) * 100) / 100} km`;
      }
      return `${Math.round(length * 100) / 100} m`;
    },
    getLineProperties(value) {
      if (!value) {
        this.lineProperties = undefined;
        return;
      } else {
        const feature = new GeoJSON().readFeature(
          {
            type: 'Feature',
            geometry: value,
            properties: {},
          },
          {
            featureProjection: 'EPSG:3857',
            dataProjection: value.crs.properties.name || 'EPSG:3857',
          }
        );
        const length = this.formatLength(feature.getGeometry());
        this.lineProperties = {
          length,
          coordinates: value.coordinates.map((coordinate, index) => {
            return {
              verboseName: `${this.$i18n.t('default.point')} ${String.fromCharCode(65 + index)}`,
              coordinates: transform(coordinate, value.crs.properties.name, this.$_config.defaultEpsg),
            };
          }),
        };
      }
    },
    formatCoordinates(coords) {
      return transform(coords, 'EPSG:3857', this.cursorPositionEpsg)
        .map(coord => coord.toFixed(4))
        .join(', ');
    },
  },
  watch: {
    geometry: {
      handler(nV) {
        this.getLineProperties(nV);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.line-summary-title-col {
  color: map-get($colors, 'fontlight');
}
</style>
